import { CSSProperties } from 'styled-components'
import { Wrapper, Content, Label } from './BlogHero.styles'
import { Body, FlexibleHeading as Heading, Spacing } from '@big-red-group/storefront-common-ui'

type BlogHeroProps = {
  title: string
  label?: string
  description?: string
  children?: React.ReactNode
  style?: CSSProperties
}

const BlogHero: React.FC<BlogHeroProps> = ({ title, label, description, children, style }) => {
  const containerStyle = { position: 'absolute' }

  return (
    <Wrapper style={style}>
      <Content>
        {label && <Label>{label}</Label>}
        <Heading size="L" alignment="center" as="h1" dataTestId="blog-hero-title" weight="bold">
          {title}
        </Heading>
        {description && (
          <>
            <Spacing size="L" />
            <Heading size="S" alignment="center" as="span" weight="medium">
              {description}
            </Heading>
          </>
        )}
      </Content>
      {children}
    </Wrapper>
  )
}

export default BlogHero
